// Create footer component

import React from 'react';

const Footer = () => {
  return (
    <footer className="footer">
      <p className='p-footer'>© 2024 Little Lemon</p>
    </footer>
  )
}

export default Footer;